import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'

Vue.use(Router)

export default new Router({
	mode: "history",
	routes: [{
			path: '/',
			name: 'login',
			component: () => import("@/views/login.vue")
		},
		{
			path: '/index',
			name: 'index',
			component: () => import("@/views/index.vue"),
			children: [{
				path: '/my',
				name: 'my',
				component: () => import("@/views/my.vue"),
				meta: {
					activeMenu: '/index'
				},
			}, {
				path: '/share',
				name: 'share',
				component: () => import("@/views/share.vue")
			}, {
				path: '/file',
				name: 'file',
				component: () => import("@/views/file.vue")
			}]
		},
	]
})



// WEBPACK FOOTER //
// ./src/router/index.js